import MasterConfig from './master-backend-api-config';
import DevConfig from './dev-api-config';

const env = import.meta.env.MODE
const Config =  env === 'production' ? MasterConfig : DevConfig;
export default Config;
